import { ImageCtaCardSection } from "@/design-system/Organisms"
import { ContactUsFormSection } from "@/design-system/Organisms"
import { contactUsImageCtaCardConfig } from "@/design-system/Organisms/ImageCtaCardSection/imageCtaCard.config"

const ContactUsTemplate = () => {
    return (
        <>
            <ContactUsFormSection />
            <ImageCtaCardSection {...contactUsImageCtaCardConfig} />
        </>
    )
}

export default ContactUsTemplate